<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow-sm">
        <div class="container-fluid">
            <div style="font-weight:600;" class="me-2"><i class="bi bi-water"></i> WATER LEVEL</div>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li v-if="$router.currentRoute.value.path=='/'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                        <a style="color: white;" class="nav-link active" aria-current="page" href="#"><i class="bi bi-geo"></i> Node List</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/" style=" text-decoration: none !important;">
                            <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-geo"></i> Node List</a>
                        </router-link>
                    </li>

                    <li v-if="$router.currentRoute.value.path=='/devices'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                        <a class="nav-link active" style="color: white;" aria-current="page" href="#"><i class="bi bi-app-indicator"></i> Devices</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/devices" style=" text-decoration: none !important;">
                            <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-app-indicator"></i> Devices</a>
                        </router-link>
                    </li>

                    <li v-if="$router.currentRoute.value.path=='/users'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                        <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-people"></i> Users</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/users" style=" text-decoration: none !important;">
                            <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-people"></i> Users</a>
                        </router-link>
                    </li>
                </ul>
                <form class="d-flex">

                    <button class="btn btn-outline rounded-5 px-3" style="color: #eb6451; border: 2px solid #eb6451;" type="submit">
                        <i class="bi bi-box-arrow-right" style="font-size: 16px;"></i> <span class="ms-1 " style="font-weight: 400;">logout</span>
                    </button>

                </form>
            </div>
        </div>
    </nav>
</div>
<!-- Modal -->
<div class="modal fade" id="addDeviceModal" tabindex="-1" aria-labelledby="addDeviceModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addDeviceModalLabel">+ Add Device</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label">SN (Serial Number)</label>
                    <input type="text" class="form-control" placeholder="เช่น 012345" />
                </div>

                <div class="mb-3">
                    <label class="form-label">Name (Location)</label>
                    <input type="text" class="form-control" placeholder="ชื่ออุปกรณ์ / จุดติดตั้ง" />
                </div>

                <div class="mb-3">
                    <label class="form-label">สถานที่ตั้ง</label>
                    <input type="text" class="form-control" placeholder="ที่อยู่ / หมู่บ้าน / ตำบล" />
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <label class="form-label">Postcode</label>
                        <input type="text" class="form-control" placeholder="รหัสไปรษณีย์" />
                    </div>
                    <div class="col-6 mb-3">
                        <label class="form-label">จังหวัด</label>
                        <input type="text" class="form-control" placeholder="จังหวัด" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <label class="form-label">Latitude</label>
                        <input type="number" step="any" class="form-control" placeholder="เช่น 14.8074" />
                    </div>
                    <div class="col-6 mb-3">
                        <label class="form-label">Longitude</label>
                        <input type="number" step="any" class="form-control" placeholder="เช่น 101.4842" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="form-label">หมายเหตุ</label>
                        <input type="text" step="any" class="form-control" placeholder="หมายเหตุ" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary rounded-5" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-dark rounded-5">Add Device</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="infolocationModal" tabindex="-1" aria-labelledby="infolocationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="infolocationModalLabel">ข้อมูลที่ตั้ง</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <p>บ้านเลขที่ 123/45 หมู่บ้านสวนแก้ว
                    ถนนประชาชื่น แขวงบางซื่อ เขตบางซื่อ
                    กรุงเทพมหานคร 10800</p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary rounded-5" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid px-2" style="margin-top: 80px;">
    <div class="border rounded-3 py-2 px-3 bg-light w-100">
        <div class="row">
            <div class="col-12 col-md-6 mt-1" style="font-size: 20px;font-weight: bold;">
                <i class="bi bi-app-indicator"></i> Devices
            </div>
            <div class="col-12 col-md-6 text-end pe-3 mt-1">
                <span>เพิ่มอุปกรณ์บนที่ตั้งได้ที่นี่ </span>
                <button type="button" class="ms-2 btn btn-dark rounded-5" data-bs-toggle="modal" data-bs-target="#addDeviceModal">+ Add Device</button>
            </div>
        </div>
    </div>

    <div class="table-responsive mt-3">
        <table class="table table-sm w-100">
            <thead>
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>SN</th>
                    <th>Name</th>
                    <th>Latitude,Longitude</th>
                    <th>สถานที่ตั้ง</th>
                    <th>Status</th>
                    <th>Edit</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in items" :key="item.id">
                    <th scope="row">{{ index+1 }}</th>
                    <td>{{ item.id }}</td>
                    <td>SN{{ item.sn }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.latLng.lat }}, {{ item.latLng.lon }}</td>
                    <td>
                        <button data-bs-toggle="modal" data-bs-target="#infolocationModal" type="button" class="btn btn-light py-0">
                            <i class="bi bi-house"></i> สถานที่ตั้ง
                        </button>
                    </td>
                    <td>
                        <span v-if="item.status==true">🟢 Online</span>
                        <span v-else>Offline</span>
                    </td>
                    <td>
                        <i class="bi bi-eye " style="font-size: 18px;"></i>
                        <i class="bi bi-pen ms-2" style="font-size: 18px;"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

</template>

<script>
export default {
    data() {
        return {
            selected_item_per_page: 100,
            items: [{
                    "name": "เขื่อนลำตะคลอง",
                    "latLng": {
                        "lat": 14.807407717907903,
                        "lon": 101.48424778491378
                    },
                    "id": 4821,
                    "sn": 739201,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "ฟาร์มโชคชัย",
                    "latLng": {
                        "lat": 14.816852657086239,
                        "lon": 101.50553321948746
                    },
                    "id": 1295,
                    "sn": 582934,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "สะพานมอเตอร์เวย์ลำตะคอง",
                    "latLng": {
                        "lat": 14.833254807713207,
                        "lon": 101.53309625055842
                    },
                    "id": 9032,
                    "sn": 294781,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "ตลาดคลองไผ่",
                    "latLng": {
                        "lat": 14.85798921843854,
                        "lon": 101.56115963186883
                    },
                    "id": 7754,
                    "sn": 135820,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "จุดชมวิวหินพิมาน",
                    "latLng": {
                        "lat": 14.832474277156239,
                        "lon": 101.5511432915936
                    },
                    "id": 6248,
                    "sn": 830157,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "โรงเรียนน้ำซับศรีสุข",
                    "latLng": {
                        "lat": 14.810490972284864,
                        "lon": 101.53904300979444
                    },
                    "id": 3819,
                    "sn": 905621,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "บ้านหินฟ้า",
                    "latLng": {
                        "lat": 14.791588668740543,
                        "lon": 101.52328248448228
                    },
                    "id": 5130,
                    "sn": 672358,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "สถานีรถไฟสีคิ้ว",
                    "latLng": {
                        "lat": 14.782136899302836,
                        "lon": 101.51450447038438
                    },
                    "id": 2940,
                    "sn": 427896,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "วัดบ้านใหม่ลำตะคอง",
                    "latLng": {
                        "lat": 14.771913093645558,
                        "lon": 101.49136243321716
                    },
                    "id": 8175,
                    "sn": 150274,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "อ่างเก็บน้ำตอนบน",
                    "latLng": {
                        "lat": 14.848553534580018,
                        "lon": 101.5492542298564
                    },
                    "id": 2367,
                    "sn": 784592,
                    "water_height": 150,
                    "status": true
                },
                {
                    "name": "เขื่อนลำตะคลอง (โซนเหนือ)",
                    "latLng": {
                        "lat": 14.779517361043826,
                        "lon": 101.48002955952902
                    },
                    "id": 9652,
                    "sn": 325190,
                    "water_height": 150,
                    "status": true
                }
            ]

        }
    },
}
</script>

<style scoped>
    .table-responsive {
    max-width: 100%;
    overflow-x: auto; /* scroll บนมือถือ */
}

.w-100 {
    width: 100% !important;
}

</style>
